/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import moment from 'moment';
import Transformer from '../transformer';
import Address from '../common/address';

export default class JobList extends Transformer {
  // check current date hours for change status to done
  static jobStatus(status, dateEnd) {
    const now = moment()
      .format('L');
    const nowHours = moment()
      .format('LT');
    const dateEndHours = moment(dateEnd)
      .format('LT');
    dateEnd = moment(dateEnd)
      .format('L');

    if (now === dateEnd) {
      if (nowHours > dateEndHours) {
        return 'done';
      }
    }
    return status;
  }

  /**
   * Method used to transform a jobs to full-calendar representation
   *
   * @param job Job
   *
   * @returns {Object} The transformed account
   */

  static fetch(job) {
    const currentDate = moment()
      .format();
    const obj = {
      id: job.id,
      dateBegin: job.date_begin,
      dateEnd: job.date_end,
      title: `${job.id}  ${job.category ? job.category.name : null}`,
      className: job.status,
      cancelPercentageRateCustomer: job.cancel_percentage_rate_customer,
      address: Address.fetch(job.address),
      category: job.category,
      description: job.description,
      status: this.jobStatus(job.status, job.date_end),
      countStudent: job.count_student,
      countStudentAsked: job.count_student_asked,
      countRefererAsked: job.count_referer_asked,
      countReferer: job.count_referer,
      student_pictures: job.student_pictures,
      global_feedback: job.global_feedback,
      pending_customer_request: job.pending_customer_request,
      template: job.template,
      tags: job.tags ? job.tags : [],
    };

    obj.isEnabledToChange = currentDate <= job.date_begin;
    // freeze property
    // Object.defineProperty(obj, 'id', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'dateBegin', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'dateEnd', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'className', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'title', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'address', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'category', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'description', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'countStudent', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'countStudentAsked', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'countRefererAsked', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'countReferer', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'student_pictures', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'global_feedback', { configurable: false, writable: false });
    // Object.defineProperty(obj, 'pending_customer_request', { configurable: false, writable: false });
    return obj;
  }
}
